<h2>{{'help.browsers.title.shortLabel' | translate}}</h2>
<p>{{'help.browsers.title.summary' | translate}}</p>

<mat-list dense>
    <mat-list-item>
        <fa-icon class="list-icon" matListIcon [icon]="['fab', 'chrome']"></fa-icon>
        <p matLine>Google Chrome 100.0 <span class="optimum">{{'help.browsers.optimum.shortLabel' | translate}}</span></p>
    </mat-list-item>
    <mat-list-item>
        <fa-icon class="list-icon" matListIcon [icon]="['fab', 'firefox']"></fa-icon>
        <p matLine>Mozilla Firefox 99.0</p>
    </mat-list-item>
    <mat-list-item>
        <fa-icon class="list-icon" matListIcon [icon]="['fab', 'safari']"></fa-icon>
        <p matLine>Safari 11.1.1</p>
    </mat-list-item>
    <mat-list-item>
        <fa-icon class="list-icon" matListIcon [icon]="['fab', 'edge']"></fa-icon>
        <p matLine>Microsoft Edge <span class="unsupported">{{'help.browsers.notSupported.shortLabel' | translate}}</span></p>
    </mat-list-item>
    <mat-list-item>
        <fa-icon class="list-icon" matListIcon [icon]="['fab', 'internet-explorer']"></fa-icon>
        <p matLine>Internet Explorer <span class="unsupported">{{'help.browsers.notSupported.shortLabel' | translate}}</span></p>
    </mat-list-item>
</mat-list>
